import React from "react";
import "../styles/navbar.css";

export default function Navbar() {
  return (
    <nav className="navbar">
      <h1 className="navbar-title"><span style={{ color: "#01e76c" }}>ELECTION</span> COMMISSION</h1>
    </nav>
  );
}